import React, { useState } from "react";
import { Button } from "reactstrap";
import "boxicons/css/boxicons.min.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthenticateProvider";
import UserIcon from '../Assets/images/user.png'

const Header = () => {
    const navigate = useNavigate();
    const { userRole, userName } = useAuth();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        const sidebar = document.querySelector('.app-sidebar');
        const overlay = document.querySelector('.sidebar-overlay');
        if (sidebar) {
            sidebar.classList.toggle('mobile-open');
        }
        if (overlay) {
            overlay.classList.toggle('active');
        }
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <React.Fragment>
            <header className="app-header">
                <div className="header-left">
                    <Button className="hamburger-btn d-lg-none" onClick={toggleMobileMenu}>
                        <i className={`bx ${mobileMenuOpen ? 'bx-x' : 'bx-menu'}`} style={{fontSize: '22px'}}></i>
                    </Button>
                    <Button onClick={() => navigate('/invoice/add')} className="add-btn d-none d-md-inline-block">New Invoice</Button>
                    <Button onClick={() => navigate('/quotation/add')} className="pos-btn d-none d-md-inline-block">New Quotation</Button>
                </div>
                <div className="header-right">
                    <span className={`role-badge ${userRole}`}>
                        <i className={`bx ${userRole === 'admin' ? 'bx-shield-quarter' : 'bx-user'}`}></i>
                        {userRole === 'admin' ? 'Admin' : 'Staff'}
                    </span>
                    <span className="user-name-text d-none d-sm-inline">{userName}</span>
                    <img className="user-avatar" src={UserIcon} alt="user" />
                </div>
            </header>
        </React.Fragment>
    )
};

export default Header;
